import { api } from '@/service/http';

export const getHistory = async (args) => {
    try {
        const { result, items } = await api('core./history', args);
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '68bf0e43-a5ff-4999-8857-6b5ee7b59834',
        };
    }
}

export const getHistoryTableGroups = async () => {
    try {
        const { result, items } = await api('core./history/tab-groups');
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '5e51e2a8-678f-461c-8a90-bb34ed8f79c4',
        };
    }
}

export const getHistoryUserDeps = async () => {
    try {
        const { result, items } = await api('core./history/users-departments');
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '37b0c2c9-585e-40c5-b5b8-e0f0e50e44d6',
        };
    }
}

